module.exports = __webpack_public_path__ + "static/media/github_icon.fef3f283.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/github_icon.png
 ** module id = 148
 ** module chunks = 0
 **/